import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "logout pointer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Avatar, {
      name: $setup.$profile.display_name,
      image_id: $setup.$profile.avatar_id,
      width: "3.8rem",
      height: "3.8rem"
    }, null, 8 /* PROPS */, ["name", "image_id"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Ellipsis, { class: "name" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.$profile.display_name), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Ellipsis, { class: "email" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.$profile.email), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Icon, {
        icon: "log-out-01",
        hoverable: "",
        width: "2rem",
        height: "2rem",
        stroke: "var(--gray-500)",
        onClick: $options.onLogout
      }, null, 8 /* PROPS */, ["onClick"])
    ])
  ]))
}